const listeners = new Set();
let expired = false;

export const sessionStore = {
    triggerExpiry() {
        if (expired) return;
        expired = true;
        listeners.forEach(fn => fn());
    },
    subscribe(fn) {
        listeners.add(fn);
        return () => listeners.delete(fn);
    },
    reset() {
        expired = false;
    }
};
